export default "__VITE_ASSET__Bh640HWD__"